import type { Deck } from "."

export const blankDeckCollection: Deck.Collection = {
  ankle_deep: [],
  waist_deep: [],
  neck_deep: [],
}
